import { Box, Grid, IconButton, Typography } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import SectionHeader from '../SectionHeader';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

const DrawerHeader = ({ onIconClick, text }: any) => (
    <Box>
        <SectionHeader containerType="drawer">
            <Grid container>
                <Grid item>
                    <IconButton
                        sx={{ mt: 0.4 }}
                        onClick={onIconClick}
                        data-testid={'drawer-icon-button-arrow-back'}
                    >
                        <ArrowBack
                            sx={{ fontSize: 27 }}
                            color="primary"
                            data-testid={'drawer-arrow-back-icon'}
                        />
                    </IconButton>
                </Grid>
                <Grid item xs>
                    <SectionHeader.DrawerTitle>
                        <Typography
                            data-testid={'drawer-title'}
                            sx={{ fontWeight: '700', mb: 0, textAlign: 'left', fontSize: '20px' }}
                        >
                            {text}
                        </Typography>
                    </SectionHeader.DrawerTitle>
                </Grid>
            </Grid>
        </SectionHeader>
    </Box>
);

const DrawerHeaderWithLeftIcon = ({ onIconClick, text, LeftIcon, subtitle }: any) => (
    <Box>
        <SectionHeader containerType="drawer">
            <Grid container alignItems="center" spacing={1} mb={2}>
                {LeftIcon && (
                    <Grid item>
                        <Box
                            sx={{
                                p: 1,
                                bgcolor: '#F0FDF4',
                                borderRadius: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            {LeftIcon}
                        </Box>
                    </Grid>
                )}
                <Grid
                    item
                    xs
                    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                >
                    <Typography
                        lineHeight={1}
                        variant="subtitle1"
                        my={0}
                        py={0}
                        sx={{ textAlign: 'left', width: '100%' }}
                    >
                        {text}
                    </Typography>
                    {subtitle && (
                        <Typography
                            sx={{
                                fontSize: '0.6875rem',
                                color: '#94a3b8',
                                fontWeight: 500,
                                fontsize: '0.875rem',
                                letterSpacing: 0.5
                            }}
                            my={1}
                            py={0}
                        >
                            {subtitle}
                        </Typography>
                    )}
                </Grid>
                <Grid item sx={{ alignSelf: 'flex-start' }}>
                    <IconButton
                        size="small"
                        onClick={onIconClick}
                        sx={{ '&:hover': { bgcolor: 'action.hover' } }}
                    >
                        <CloseOutlinedIcon fontSize="medium" sx={{ color: 'text.secondary' }} />
                    </IconButton>
                </Grid>
            </Grid>
        </SectionHeader>
    </Box>
);
export { DrawerHeader, DrawerHeaderWithLeftIcon };
